<script setup lang="ts">
import type { Stats } from '../../atoms/AStats/types';

defineProps<{
  compact?: boolean;
  isDirectValue?: boolean;
  loading?: boolean;
  stats: Stats;
}>();
</script>

<template>
  <AStats
    :compact
    :isDirectValue
    :loading
    :stats
  />

  <AStatsSkeleton v-if="loading" />

  <AStatsEmptyState v-if="Array.isArray(stats) && !stats.length && !loading" />
</template>
